// ** React Imports
import { Fragment, useState } from "react";

// ** Custom Components
import Avatar from "@components/avatar";

// ** Third Party Components
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Bell,
  X,
  Check,
  AlertTriangle,
  Video,
  ArrowRightCircle,
  MessageSquare,
  PieChart,
} from "react-feather";

// ** Reactstrap Imports
import {
  Badge,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  TabContent,
  TabPane,
  Nav,
} from "reactstrap";
import Tabs from "../../../../Shared/Tabs";
import { useSelector } from "react-redux";

const TabsJustified = ({ trending_videos_count, count }) => {
  const [active, setActive] = useState("priority");
  const toggle = (tab) => {
    if (active !== tab) {
      setActive(tab);
    }
  };
  return (
    <Fragment>
      <Nav tabs className="justify-content-center">
        <Tabs
          // tabs={["priority", "upcoming"]}
          tabs={["priority"]}
          active={active}
          toggle={toggle}
        />
      </Nav>
      <TabContent className="py-50" activeTab={active}>
        <TabPane tabId="priority">
          <div className="row">
            <div className="col-1 ms-2">
              <b>Today</b>
            </div>
            {/* @TODO */}
            <div className="col-1 ms-1">
              ({trending_videos_count > 0 ? 1 : 0})
            </div>
          </div>
          {trending_videos_count > 0 && (
            <div className="row p-1">
              <div className="col-1 ms-1">
                <Video />
              </div>
              <div className="col-8">You have new trending videos</div>
              <div className="col-2">
                <ArrowRightCircle color="#783AD0" />
              </div>
            </div>
          )}
          {count == 0 && (
            <div className="row p-1">
              <div className="col-12">You have no new notification</div>
            </div>
          )}
          {/* <div className="row p-1">
            <div className="col-1 ms-1">
              <MessageSquare />
            </div>
            <div className="col-8">You have new chat messages</div>
            <div className="col-2">
              <ArrowRightCircle color='#783AD0' />
            </div>
          </div> */}
          {/* <div className="row p-1">
            <div className="col-1 ms-1">
              <PieChart />
            </div>
            <div className="col-8">Your customized report is ready</div>
            <div className="col-2">
              <ArrowRightCircle color='#783AD0' />
            </div>
          </div> */}
        </TabPane>
        {/* <TabPane tabId="upcoming">
          <div className="row">
            <div className="col-3 ms-2">
              <b>Next Week</b>
            </div>
          </div>

          <div className="row p-1">
            <div className="col-1 ms-1">
              <Video />
            </div>
            <div className="col-8">You have new trending videos</div>
            <div className="col-2">
              <ArrowRightCircle color='#783AD0' />
            </div>
          </div>
          <div className="row p-1">
            <div className="col-1 ms-1">
              <MessageSquare />
            </div>
            <div className="col-8">You have new chat messages</div>
            <div className="col-2">
              <ArrowRightCircle color='#783AD0' />
            </div>
          </div>
        </TabPane> */}
      </TabContent>
    </Fragment>
  );
};

const NotificationDropdown = () => {
  const priority_notification = useSelector(
    (state) => state.navbarStatsReducer.priority_notification
  );
  // ** Function to render Notifications
  /*eslint-enable */
  const { trending_videos_count, new_videos_count } =
    priority_notification || {};
  let count = 0;
  if (trending_videos_count > 0) {
    count += 1;
  }
  return (
    <UncontrolledDropdown
      tag="li"
      className="dropdown-notification nav-item me-25"
    >
      <DropdownToggle
        tag="a"
        className="nav-link"
        href="/"
        onClick={(e) => e.preventDefault()}
      >
        <Bell size={21} />
        {count > 0 ? ( //Check other fields counts
          <Badge pill color="danger" className="badge-up">
            {count}
          </Badge>
        ) : null}
      </DropdownToggle>
      <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0">
        <TabsJustified
          trending_videos_count={trending_videos_count}
          count={count}
        />
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default NotificationDropdown;
